import { FormikProps } from 'formik';
import { ValidationResult } from 'modules/campaign-creation/types/ValidationResult';

/**
 * Validates a Formik form and returns a ValidationResult.
 * If validation fails, submits the form to show validation errors.
 * If validation passes, submits the form to save data.
 *
 * @param formik - The Formik form instance
 * @param errorMessage - Optional custom error message (defaults to 'Please fix the form errors.')
 * @returns ValidationResult with isValid, tasks (empty array), and error message
 */
export const validateFormikForm = async <T>(
  formik: FormikProps<T>,
  errorMessage = 'Please fix the form errors.'
): Promise<ValidationResult> => {
  const errors = await formik.validateForm();
  const hasErrors = Object.keys(errors).length > 0;

  if (hasErrors) {
    // Touch all fields to show validation errors
    await formik.submitForm();
    return { isValid: false, tasks: [], error: errorMessage };
  }

  // Submit the form to save data
  await formik.submitForm();
  return { isValid: true, tasks: [] };
};
